interface Coordinates {
  latitude: number;
  longitude: number
}
interface MapSize {
  height: number;
  width: number
}

export const mapCoordinatesToPosition = (villaCoordinates: Coordinates, mapEnd: MapSize) => {
    const sicilyOrigin = {
        latitude: 38.81728485,
        longitude: 11.92481948,
    };

    const sicilyEnd = {
        latitude: 36.64863391,
        longitude: 15.65467788,
    };

    const mapOrigin = { top: 0, left: 0 };

    const pointCoordinates = {
      top: (((villaCoordinates.latitude - sicilyOrigin.latitude) *
        (mapEnd.height - mapOrigin.top)) /
        (sicilyEnd.latitude - sicilyOrigin.latitude)) +
        mapOrigin.top,
      left: (((villaCoordinates.longitude - sicilyOrigin.longitude) *
        (mapEnd.width - mapOrigin.left)) /
        (sicilyEnd.longitude - sicilyOrigin.longitude)) +
        mapOrigin.left, 
    };

    return pointCoordinates;
};